import { baseService } from "src/store/base.store";
import { Organization, Project } from "./types/organization.entity";
import { executeQuery } from "src/store";
import { organizationRepository } from "./organization.repository";

export const organizationService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationById: builder.query<Organization, string>({
      queryFn: async (id) => executeQuery(() => organizationRepository.findById(id)),
    }),

    getAllOrganizations: builder.query<Organization[], number | void>({
      queryFn: async (limit) => executeQuery(() => organizationRepository.find({ limit: limit ?? 10 })),
    }),

    createOrganization: builder.mutation<string, Partial<Organization>>({
      queryFn: async (organizationData) => executeQuery(() => organizationRepository.create(organizationData)),
    }),

    updateOrganization: builder.mutation<void, { id: string; data: Partial<Organization> }>({
      queryFn: async ({ id, data }) => {
        return executeQuery(() => organizationRepository.update(id, data));
      },
    }),

    getOrganizationProjects: builder.query<Project[], string>({
      queryFn: async (orgId) => await executeQuery(() => organizationRepository.getOrganizationProjects(orgId)),
    }),
  }),
});

export const {
  useGetOrganizationByIdQuery,
  useGetAllOrganizationsQuery,
  useGetOrganizationProjectsQuery,
  useCreateOrganizationMutation,
  useUpdateOrganizationMutation,
} = organizationService;
